import React from 'react';
import cn from 'classnames';

import ZoomSliderPure from '@Containers/Zoom/ZoomSlider/ZoomSliderPure';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import RsTableToolbarButton from '@Pages/RetroSynthesis/components/RsTableToolbarButton';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import PropTypes from 'prop-types';
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from '../constants';

import './ProjectRouteTreeViewTopPanel.theme.scss';

const routeTypeClassName = (routeType) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return 'project-route-tree-view-top-panel__label__published';
    case RouteType.PREDICTED:
      return 'project-route-tree-view-top-panel__label__predicted';
    case RouteType.CUSTOMIZED:
      return 'project-route-tree-view-top-panel__label__customized';
    default:
      return null;
  }
};

const routeTypeLabel = (routeType, routeId) => {
  switch (routeType) {
    case RouteType.PUBLISHED:
      return `Published route #${routeId}`;
    case RouteType.PREDICTED:
      return `Predicted route #${routeId}`;
    case RouteType.CUSTOMIZED:
      return `Customized route #${routeId}`;
    default:
      return null;
  }
};

function ProjectRouteTreeViewTopPanel({ treeViewRef, zoom, zoomOnChange, rotateOnClick, fitOnClick, copyOnClick, routeId, routeType }) {
  const hoverTreeNodesClass = 'project-route-tree--hover-tree';
  const addHoverClass = () => {
    treeViewRef.current.classList.add(hoverTreeNodesClass);
  };
  const removeHoverClass = () => {
    treeViewRef.current.classList.remove(hoverTreeNodesClass);
  };

  return (
    <RsTableToolbar className="rs-table-toolbar--transparent project-route-tree-view-top-panel">
      <div className="rs-table-toolbar__left-controls project-route-tree-view-top-panel__controls">
        <RsTableToolbarButton icon="rotate" label="Rotate" onClick={rotateOnClick} />
        <RsTableToolbarButton icon="scale-up" label="Fit view" onClick={fitOnClick} />
        <RsTableToolbarButton
          icon="duplicate-document"
          label="Copy route"
          onClick={copyOnClick}
          onMouseEnter={addHoverClass}
          onMouseLeave={removeHoverClass}
          onFocus={addHoverClass}
          onBlur={removeHoverClass}
        />
        <ZoomSliderPure
          className="project-route-tree-view-top-panel__slider"
          min={ZOOM_MIN}
          max={ZOOM_MAX}
          step={ZOOM_STEP}
          value={zoom}
          onChanged={zoomOnChange}
        />
      </div>
      <div className="rs-table-toolbar__center-controls" />
      <div className={cn('rs-table-toolbar__right-controls project-route-tree-view-top-panel__label', routeTypeClassName(routeType))}>
        {routeTypeLabel(routeType, routeId)}
      </div>
    </RsTableToolbar>
  );
}

ProjectRouteTreeViewTopPanel.propTypes = {
  treeViewRef: PropTypes.object,
  zoom: PropTypes.number,
  zoomOnChange: PropTypes.func,
  rotateOnClick: PropTypes.func,
  fitOnClick: PropTypes.func,
  copyOnClick: PropTypes.func,
  routeId: PropTypes.string,
  routeType: PropTypes.string,
};

export default ProjectRouteTreeViewTopPanel;
